/**
 * File: dateRangeUtils.ts
 * Path: apps/admin/src/features/dashboard/utils/dateRangeUtils.ts
 * Description: Date helpers for the analysis range picker: the preset list, ISO day strings and the display format.
 */

export interface DateRange {
  startDate: string;
  endDate: string;
}

export const DATE_PRESETS = [
  { label: "7", text: "Last 7 Days" },
  { label: "30", text: "Last 30 Days" },
  { label: "90", text: "Last 90 Days" },
  { label: "365", text: "Last Year" },
] as const;

/** A date as `YYYY-MM-DD`. */
export const isoDay = (date: Date): string => date.toISOString().split("T")[0];

/** The day `days` before `now`, as `YYYY-MM-DD`. */
export const presetStartDay = (days: number, now: Date = new Date()): string => {
  const start = new Date(now);
  start.setDate(start.getDate() - days);
  return isoDay(start);
};

export const formatDisplayDate = (dateStr: string): string => {
  if (!dateStr) return "---- -- --";
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};
